/**
 * Following the "partials/marks.css" which are the editor's special colors that optimize for light/dark theme
 */
export const EDITOR_MARK_SPECIAL_COLORS = ["yellow", "blue", "red", "purple", "green"];

export const EDITOR_CSS_VAR = {
    // from richEditor.css .ProseMirror padding-left/right
    SIDE_PADDING: "var(--editor-side-padding)",
} as const;
